module.exports = __webpack_public_path__ + "img/arrow_left.2184d7f2.svg";